import styled from "@mui/material/styles/styled";
import BazaarCard from "src/lib/components/salify-next-layout/default/components/Card";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box";
import { Span } from "src/lib/components/salify-next-layout/default/components/Typography";
import { footMartLayoutConstant } from "src/lib/utils/constants";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import { toAssetImages } from "src/lib/utils";

export const SidebarContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  ".sidenav": {
    top: 0,
    bottom: 0,
    position: "relative",
    transition: "all 350ms ease-in-out",
    width: footMartLayoutConstant.grocerySidenavWidth,
    minWidth: footMartLayoutConstant.grocerySidenavWidth,
    "& .MuiPaper-root": {
      background: theme.palette.info.contrastText,
      border: `1px solid ${theme.palette.paste[50]}`,
      borderRadius: 8,
      boxShadow: "0px 1px 6px 0px #00000008",
      padding: "1rem .5rem",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  ".pageContent": {
    width: `calc(100% - 2.5rem - ${footMartLayoutConstant.grocerySidenavWidth}px)`,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    ".categories": {
      "@media only screen and (min-width: 768px)": {
        padding: "1rem",
        background: theme.palette.info.contrastText,
        border: "1px solid #F2F2F5",
        borderRadius: 8,
        boxShadow: "0px 1px 6px 0px #00000008",
      },
    },
  },
}));

export const NavbarRoot = styled(BazaarCard, {
  shouldForwardProp: (prop) => prop !== "fixed" && prop !== "sidebar",
})(({ fixed, theme, sidebar }) => ({
  height: "100%",
  boxShadow: "none",
  borderRadius: "8px",
  position: "relative",
  overflow: fixed ? "auto" : "unset",
  padding: "8px",
  "& .linkList": {
    padding: ".5rem 1rem",
    transition: "all 0.2s",
  },
  ...(sidebar === "style2" && {
    // height: "100%",
    paddingBottom: 10,
    backgroundColor: theme.palette.primary[50],
  }),
}));
export const StyledNavbarLinkItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})(({ theme, isSelected }) => ({
  borderRadius: 6,
  background: isSelected ? "white" : "inherit",
  border: isSelected ? "border: 1px solid #F2F2F5" : "none",
  boxShadow: isSelected ? theme.shadows[1] : "none",
  "&:hover": {
    background: theme.palette.light.light2,
  },
}));
export const BorderBox = styled(FlexBetween, {
  shouldForwardProp: (prop) => prop !== "line",
})(({ theme, line }) => ({
  marginTop: 5,
  marginBottom: 15,
  "& span": {
    width: "100%",
  },
  ...(line === "dash" && {
    borderBottom: "2px",
    borderStyle: "none none dashed none",
    borderColor: theme.palette.primary.main,
    "& span": {
      display: "none",
    },
  }),
}));
export const ColorBorder = styled(Span, {
  shouldForwardProp: (prop) => prop !== "grey",
})(({ grey, theme }) => ({
  borderRadius: "2px 0 0 2px",
  height: grey ? "2px" : "3px",
  background: grey ? theme.palette.grey[400] : theme.palette.primary[200],
}));
export const Circle = styled("span")({
  width: "4px",
  height: "4px",
  marginLeft: "2rem",
  marginRight: "8px",
  borderRadius: "3px",
});

export const SectionContainer = styled("div")({
  margin: "auto",
  maxWidth: "1200px",
  paddingBottom: "3rem",
});
export const StyledFlexBox = styled(FlexBox)(({ theme }) => ({
  flexWrap: "wrap",
  background: "#fff",
  alignItems: "center",
  padding: "1.5rem 0.8rem",
  justifyContent: "center",
  border: `1px solid ${theme.palette.grey[300]}`,
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
    padding: "1rem 0.5rem",
    flexDirection: "column",
  },
}));
export const IconBox = styled(FlexBox)(({ theme }) => ({
  padding: "12px",
  fontSize: "22px",
  borderRadius: "50%",
  alignItems: "center",
  background: theme.palette.info[50],
}));

const BOX_STYLE = {
  minHeight: 200,
  display: "flex",
  borderRadius: 8,
  boxShadow: "none",
  alignItems: "center",
  backgroundPosition: "right bottom",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};

export const OfferBox = styled(Card, {
  shouldForwardProp: (prop) => prop !== "bgImg",
})(({ theme, bgImg }) => ({
  ...BOX_STYLE,
  backgroundImage: `url('${toAssetImages(bgImg)}')`,
}));
export const ContentBox = styled(Box)(({ theme }) => ({
  width: "50%",
  paddingLeft: 30,
  paddingTop: 28,
  paddingBottom: 28,
  minWidth: 220,
  "& p": {
    fontSize: 13,
    lineHeight: 1.4,
  },
}));
export const StyledButton = styled(Button)({
  fontWeight: 700,
  fontSize: "14px",
  marginTop: "16px",
  color: "white",
  borderRadius: 900,
});

export const CAROUSEL_ARROW_STYLE = {
  width: 35,
  height: 35,
  borderRadius: 0,
  boxShadow: 2,
  color: "primary.main",
  backgroundColor: "primary.50",
  "&:hover": {
    backgroundColor: "primary.100",
  },
};
